import { useState } from 'react';
import { useDrawer } from '../../../shared/drawer';
import { Table } from "../../../elements/table";
import { PageBody } from '../../../elements/page-body';
import { ModelosForm } from "./modelos-form";


export const ModelosPage = () => {
    const { open, close } = useDrawer();
    const [refresh, setRefresh] = useState<string | null>(null);

    const handleNewAction = () => {
        open('common.form-title.new', <ModelosForm close={handleClose} />);
    }; 

    const handleClose = () => {
        setRefresh(Date.now().toString());
        close();
    };





    return (
        <PageBody
            title={'common.label.modelos'}
            newAction={handleNewAction}
            newActionTitle={'common.form-title.new'}
        >
            <>
            <Table
                path="/fleet/car-models/"
                deletePath="/fleet/car-models/"
                callBeforeDrawerClosed={handleClose}
                Form={ModelosForm}
                withPagination
                refresh={refresh}
                headers={[
                    {
                        key: 'name',
                        label: 'common.label.modelo',
                    },
                    {
                        key: 'brand',
                        label: 'common.label.marca',
                    },
                    /* {
                        key: 'start_production_date',
                        label: 'common.form-label.fabricado-desde',
                        type: 'date'
                    },
                    {
                        key: 'end_production_date',
                        label: 'common.form-label.fabricado-hasta',
                        type: 'date'
                    } */
                ]}
            /></>
            
        </PageBody>
    );
};